import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  customWhiteBadge: {
    color: "black",
    backgroundColor: "white",
  },
  filterCountBadge: {
    marginRight: 4,
    marginLeft: 8,
  },
  moreFiltersContainer: {
    [theme.breakpoints.down("md")]: {
      position: "sticky",
      top: "90%",
      zIndex: theme.zIndex.inventory.moreFiltersButton,
      backgroundColor: "white",
      borderRadius: 1000,
      left: "calc(50% - 106px/2)",
    },
  },
  buttonLabel: {
    whiteSpace: "nowrap",
    fontWeight: 400,
  },
}));
